import { type SetStateAction, createContext } from 'react';

import { type ProductVariants } from '@/common/types/product-details.type';

interface ProductContextType {
  selectedVariants: ProductVariants | null;
  selectedImageIndex: number;
  setSelectedImageIndex?: React.Dispatch<SetStateAction<number>>;
}

export const ProductContext = createContext<ProductContextType>({
  selectedVariants: null,
  selectedImageIndex: 0,
});
